module.exports = __webpack_public_path__ + "images/CC_Topic Portal V3_Topic Portal Placeholder Icon.png";